<template>
  <v-container fluid class="pa-0">
    <div class="ma-4">
      <v-dialog v-model="newMedicationDialog">
        <v-card>
          <v-card-title class="error white--text">THIS CLIENT HAS A NEW MEDICATION</v-card-title>
          <v-divider></v-divider>
          <v-card-subtitle class="mt-2">
            A new medication of <strong>{{newMedication}}</strong> has been added on {{newMedicationDate}}. 
          </v-card-subtitle>
          <v-card-actions>
            <v-btn @click="newMedicationDialog=false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <overlay
        color="primary"
        size="50"
        message="Loading"
        :isLoading="$store.state.medications.isLoading"
      />

      <ClientNav />
      <v-row dense>
        <v-col cols="12" lg="3" xl="2">
          <ClientSide ref="clientData" />
        </v-col>
        <v-col cols="12" lg="9" xl="10">
          <v-row :class="defaultMargin">
            <v-card flat>
              <v-card-title class="text-display-4"
                >Medication - MAR</v-card-title
              >
              <v-card-text>
                <div class="text-body-2">
                  Medications that need to be administered today
                </div>
              </v-card-text>
            </v-card>
          </v-row>
          <v-divider :class="defaultMargin"></v-divider>
          <v-row :class="defaultMargin">
            <v-btn-toggle>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="white"
                    @click="togglePage"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>
                      {{
                        page === "mar"
                          ? "mdi-format-list-bulleted"
                          : "mdi-card-text-outline"
                      }}</v-icon
                    >
                  </v-btn>
                </template>
                <span>{{ page === "mar" ? "MAR History" : "MAR Card" }}</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="white"
                    @click="toggleUnsignedPage('unverified')"
                    v-if="!directCareStaff"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-format-list-text</v-icon>
                  </v-btn>
                </template>
                <span>Unverified MAR</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="white"
                    @click="toggleUnsignedPage('unsigned')"
                    v-if="!directCareStaff"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-list-status</v-icon>
                  </v-btn>
                </template>
                <span>Unsigned MAR</span>
              </v-tooltip>
            </v-btn-toggle>
          </v-row>

          <div :class="defaultMargin">
            <MarCardItem
              v-if="page === 'mar'"
              :morningMedications="morningMedications"
              :afternoonMedications="afternoonMedications"
              :eveningMedications="eveningMedications"
              :dailyPRNMedications="dailyPRNMedications"
              :newMedicationShow="newMedicationShow"
              @on-add-signature="(item) => addSignature(item)"
              :staff="staff"
              :userSignatureTz="userSignatureTz"
              @getMAR="getMARData"
              :med-certified="$store.state.users.user.MedCertified"
              ref="mar"
              :userRole="userRole"
            />

            <MarHistory
              v-if="showPage"
              :dialog="dialog"
              @close="dialog = false"
              :staff="staff"
              @getMAR="getMARData"
              :isPageHistory="isPageHistory"
              :page="page"
              :userSignatureTz="userSignatureTz"
              :isAuditorRole="userRole"
            />

            <verified-list
              v-if="page == 'unverified'"
              :clientID="clientID"
              :staff="staff"
              :userSignatureTz="userSignatureTz"
              :userRole="userRole"
            />
          </div>
        </v-col>
      </v-row>
      <Foot />
    </div>
  </v-container>
</template>
<script>
/*eslint-disable */

import axios from "axios";
import ClientNav from "../../components/ClientNav";
import ClientSide from "../../components/ClientSide";
import Foot from "../../components/Footer";
import moment from "moment";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { setUserTz, tz } from "../../../utils/timezone";

// components
import MarHistory from "../../components/medications/MAR/MarHistory";
import MarCardItem from "@/components/medications/MAR/MarCardItem";
import VerifiedList from "@/components/medications/MAR/MarVerifiedList";

//shared components
import overlay from "@/components/shared/Overlay";

import { v4 as uuidv4 } from "uuid";
// BUG: The v-card only disables after clicking any "Submit" button
const url = require("../../client_config/config").url;

// CONSTANT VARIABLES

// import {MORNING as SchedMorning, AFTERNOON as schedAfternoon, EVENING as schedEvening } from "../../constants/ScheduleTime"

import schedule from "../../constants/ScheduleTime"

let MORNING = schedule.MORNING()
let AFTERNOON = schedule.AFTERNOON()
let EVENING = schedule.EVENING()
let EVENING2 = schedule.EVENING2()




// const MORNING = ["6:00am", "7:00am", "8:00am", "9:00am", "10:00am", "11:00am"];
// const MORNING = SchedMorning()

// const AFTERNOON = ["12:00pm", "1:00pm", "2:00pm", "3:00pm", "4:00pm", "5:00pm"];
// const AFTERNOON = schedAfternoon()

// const EVENING = [
//   "6:00pm",
//   "7:00pm",
//   "8:00pm",
//   "9:00pm",
//   "10:00pm",
//   "11:00pm",
//   "12:00am",
//   "1:00am",
//   "2:00am",
//   "3:00am",
//   "4:00am",
//   "5:00am",
// ];
// const EVENING = schedEvening()

export default {
  components: {
    ClientNav,
    ClientSide,
    Foot,
    MarHistory,
    MarCardItem,
    VerifiedList,
    overlay,
  },
  data: () => ({
    showDialog: false,
    directCareStaff: false,
    url: url,
    page: "mar",
    clientID: localStorage.getItem("clientId"),
    userID: localStorage.getItem("userID"),
    tempData: [],
    date: new Date(),
    medications: [],
    morningMedications: [],
    afternoonMedications: [],
    eveningMedications: [],
    dailyPRNMedications: [],
    search: "",
    isSaving: false,
    exceptions: [
      "Absent",
      "Dropped",
      "Medication Unavailable",
      "Spit Out",
      "Meds on Hold",
      "Refused",
      "Low Vitals",
      "Other",
    ],

    dialog: false,
    disabled: false,
    color: "",
    mars: [],
    users: [],
    signed: false,
    staff: localStorage.getItem("Name"),
    marID: "",
    newMedication: "",
    newMedicationId: "",
    newAmountAdministered: "",
    newAdminTime: "",
    newNotes: "",
    newException: "",
    newSignature: "",
    newSignatureData: "",
    newSignatureDataAdd: "",
    newDate: "",
    editedIndex: -1,
    Quantity: "",
    qty: [],

    adminTime: [
      "12:00am",
      "1:00am",
      "2:00am",
      "3:00am",
      "4:00am",
      "5:00am",
      "6:00am",
      "7:00am",
      "8:00am",
      "9:00am",
      "10:00am",
      "11:00am",
      "12:00pm",
      "1:00pm",
      "2:00pm",
      "3:00pm",
      "4:00pm",
      "5:00pm",
      "6:00pm",
      "7:00pm",
      "8:00pm",
      "9:00pm",
      "10:00pm",
      "11:00pm",
      "PRN",
    ],
    isLoading: true,
    newMedicationDialog: false,
    newMedicationShow: false,
    newMedicationDate: "",
    isPageHistory: true
  }),

  async created() {
    this.clientID = this.$route.params.clientID;
    await this.fetchUser();
    this.getMARData();
    // this.getSharedLink();
    //this.getUsers();
    console.log("mar");
    this.currentPage(this.$route.params.page);
    MORNING =  MORNING.concat(EVENING2);
  },

  computed: {
    ...mapGetters({
      getUserTimezone: "timezones/getUserTimezone",
      getDefaultTz: "timezones/getDefaultTz",
      getMAR: "medications/getMAR",
      getAllClientMedications: "medications/getAllClientMedications",
    }),

    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },

    clientData() {
      return this.$refs.clientData.getClientData();
    },

    userTimezone() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return setUserTz(data);
    },

    userSignatureTz() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return data;
    },

    showPage(){
      return this.page == 'history' || 'unsigned' && this.page  != 'mar' && this.page  != 'unverified'
    },

    defaultMargin() {
      return this.$vuetify.breakpoint.xsOnly ? "ma-0 my-3" : "ma-3";
    },
    userRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    ...mapActions({
      fetchUser: "timezones/fetchUser",
      fetchMAR: "medications/fetchMAR",
      addTask: "tasks/AddTask",
    }),

    ...mapMutations({
      setLoading: "medications/SET_LOADING",
      setDisableButton: "medications/SET_DISABLE_BUTTON",
    }),

    initialize() {
      this.mars = [];
    },

    getMARData() {
      const data = {
        id: this.clientID,
        userTimezone: this.userTimezone,
      };
      this.fetchMAR(data).then(() => {
        this.getMedication();
      });
    },

    async getMedication() {
      this.setLoading(true);
      await axios
        .get(`${url}/medications/client/${this.clientID}`)
        .then((res) => {
          this.medications = res.data.medications;

          this.morningMedications = [];
          this.afternoonMedications = [];
          this.eveningMedications = [];
          this.dailyPRNMedications = [];
          this.tempData = res.data.medications;
          let count = 1;

          for (var i = 0; i < this.tempData.length; i++) {
            //To prevent the forms from duplicating the input
            if(moment(this.date).isBefore(moment(this.tempData[i].createdAt).add(7, 'days'))){
              this.newMedicationDialog = true
              this.newMedication = this.tempData[i].Medication
              this.newMedicationShow = true
              this.newMedicationDate = moment(this.tempData[i].createdAt).format("MM/DD/YYYY hh:mma")
            }
            this.tempData[i].index = count++;
            this.tempData[i].newNotes = "";
            this.tempData[i].newAmountAdministered = this.amountAdministered(this.tempData[i].Dosage, this.tempData[i].Quantity )
            this.tempData[i].newAdminTime = "";
            this.tempData[i].newException = "";
            this.tempData[i].newSignature = "";
            this.tempData[i].error = "";
            this.tempData[i].insulinError = "";
            this.tempData[i].Insulin = "";
            this.tempData[i].signed = false;

            //let medicationStartDate = this.tempData[i].StartDate;
            //let medicationEndDate = this.tempData[i].EndDate;
            let tempDaysOfWeek = this.tempData[i].DaysOfWeek;
            let tempIntervalDays = this.tempData[i].IntervalDays;
            let tempDaysOfMonth = this.tempData[i].DaysOfMonth;

            //Initalized AdminTime value to PRN if AdminTime is Empty
            let adminTime =
              this.tempData[i].AdminTime.length != 0
                ? this.tempData[i].AdminTime
                : ["PRN"];

            // Check all available Admin Time
            adminTime.forEach((time) => {
              // Check if Morning, Afternoon, or Evening, or PRN for default/no time
              this.tempData[i].newAdminTime = time;
              this.tempData[i].time = time;
              this.tempData[i].isAdministered = this.isSigned({
                ...this.tempData[i],
                AdminTime: time,
              });

              //NEW VITAL SIGNS INITIALIZE
              let newVitalSigns = [];
              this.tempData[i].VitalsRequired.forEach((value) => {
                newVitalSigns.push("");
              });
              this.tempData[i].newVitalsRequired = newVitalSigns;
              this.tempData[i].ErrorVitalsRequired = [];

              let tempCard = Object.assign({}, this.tempData[i]);
              let checkTodayDayOfWeek = true;
              let checkIntervalDays = true;
              let checkDaysOfMonth = true;

              //DISPLAYING DAYS OF WEEK
              if (tempDaysOfWeek.length > 0) {
                if (tempDaysOfWeek[0] !== "") {
                  checkTodayDayOfWeek = false;
                  let dayToday = moment(Date.now()).format("dddd");
                  let dayOfWeek = tempDaysOfWeek.filter(function(elem) {
                    if (elem == dayToday) return elem;
                  });
                  if (dayOfWeek.length > 0) checkTodayDayOfWeek = true;
                }
              }

              //DISPLAYING DAYS OF MONTH
              if (tempDaysOfMonth.length > 0) {
                if (tempDaysOfMonth[0] !== "") {
                  checkDaysOfMonth = false;
                  let numDayToday = moment(Date.now()).format("D");
                  let dayOfMonth = tempDaysOfMonth.filter(function(elem) {
                    if (elem == numDayToday) return elem;
                  });
                  if (dayOfMonth.length > 0) checkDaysOfMonth = true;
                }
              }

              //DISPLAYING INTERVAL DAYS
              if (tempIntervalDays.length > 0) {
                if (tempIntervalDays[0] !== "") {
                  let intervalStartDate = moment(tempCard.StartDate).subtract(tempIntervalDays, 'd').format(
                    "YYYY-MM-DD"
                  );
                  let intervalEndDate = moment(tempCard.EndDate).format(
                    "YYYY-MM-DD"
                  );
                  let dateIntervalNow = moment(Date.now()).format("YYYY-MM-DD");
                  let intervalDay = tempCard.IntervalDays;

                  let intervalDaysDuration = moment
                    .duration(
                      moment(intervalEndDate, "YYYY-MM-DD").diff(
                        moment(intervalStartDate, "YYYY-MM-DD")
                      )
                    )
                    .asDays();
                  checkIntervalDays = false;
                  let calculateInterval =
                    parseInt(intervalDaysDuration) / parseInt(intervalDay);
                  const intervalDates = [];

                  for (let i = 0; i < calculateInterval; i++) {
                    let getIntervalDays = moment(
                      intervalStartDate,
                      "YYYY-MM-DD"
                    )
                      .add(intervalDay, "days")
                      .format("YYYY-MM-DD");
                    intervalStartDate = getIntervalDays;
                    intervalDates.push(getIntervalDays);
                  }

                  let checkIntervalDay = intervalDates.filter(function(value) {
                    if (value == dateIntervalNow) return value;
                  });

                  if (checkIntervalDay.length > 0) checkIntervalDays = true;
                }
              }

              if (
                checkTodayDayOfWeek === true &&
                checkDaysOfMonth === true &&
                checkIntervalDays === true
              ) {
                // CHECKING FOR specific days of the month
                // Added Generated UUID for filtering Multiple Selected Items
                if (MORNING.includes(time)) {
                  try {
                    this.morningMedications.push({
                      ...tempCard,
                      generatedId: uuidv4(),
                    });
                  } catch (error) {
                    console.log(error);
                  }
                } else if (AFTERNOON.includes(time)) {
                  try {
                    this.afternoonMedications.push({
                      ...tempCard,
                      generatedId: uuidv4(),
                    });
                  } catch (error) {
                    console.log(error);
                  }
                } else if (EVENING.includes(time)) {
                  try {
                    this.eveningMedications.push({
                      ...tempCard,
                      generatedId: uuidv4(),
                    });
                  } catch (error) {
                    console.log(error);
                  }
                } else {
                  try {
                    this.dailyPRNMedications.push({
                      ...tempCard,
                      generatedId: uuidv4(),
                    });
                  } catch (error) {
                    console.log(error);
                  }
                }
              } else {
                console.log(tempCard);
                /*
                let tempDaysOfWeek = this.tempData[i].DaysOfWeek;
                let tempIntervalDays = this.tempData[i].IntervalDays;
                let tempDaysOfMonth = this.tempData[i].DaysOfMonth;
                */
                //let tempDaysOfWeek = this.tempData[i].DaysOfWeek;
                //DISPLAYING DAYS OF WEEK
                console.log(tempDaysOfWeek[0] + "Check if Empty");
                if (tempDaysOfWeek.length > 0) {
                  if (tempDaysOfWeek[0] !== "") {
                    checkTodayDayOfWeek = false;
                    let dayToday = moment(Date.now()).format("dddd");
                    let dayOfWeek = tempDaysOfWeek.filter(function(elem) {
                      console.log(elem + "elem");
                      if (elem == dayToday) return elem;
                    });
                    console.log(dayOfWeek.length);
                    if (dayOfWeek.length > 0) checkTodayDayOfWeek = true;
                  } else {
                    console.log("No Date");
                  }
                }
                console.log(tempDaysOfWeek.length + " - WEEK");
                console.log(tempIntervalDays.length + " - Days");
                console.log(tempDaysOfMonth.length + " - Month");
              }
            });
          }
        })

        .finally(() => (this.setLoading(false), this.setDisableButton(false)));
    },

    isSigned: function(med) {
      let result = false;
      // let tzdate = tz(new Date(), this.usertz).format("MM-DD-YYYY")
      // (item) => item.Medication._id == med._id && tz(item.Date, this.userTimezone).isSame(moment(Date.now()), "day")
      // (item) => item.Medication._id == med._id && moment(new Date(item.Date)).isSame(moment(Date.now()), "day")
      this.getMAR
        .filter(
          (item) =>
            item.Medication._id == med._id &&
            item.AdminTime === med.newAdminTime &&
            tz(item.Date, this.userTimezone).isSame(moment(Date.now()), "day")
        )
        .forEach((mar) => {
           
          // Condition for DAILY MAR:
          // 1. If the current Medication exists in the MAR History list
          // 2. If the date of the matching MAR History item happened TODAY
          // 3. If the adminTime is PRN or BLANK, then time of the day wouldn't matter as long as the date is TODAY
          // 4. OR if the time category of the MAR History matches with the Medication's time category, then it means it's administered already.
          if (
            mar.AdminTime == "PRN" ||
            mar.AdminTime == "" ||
            med.newAdminTime == "" ||
            (MORNING.includes(mar.AdminTime) &&
              MORNING.includes(med.newAdminTime)) ||
            (AFTERNOON.includes(mar.AdminTime) &&
              AFTERNOON.includes(med.newAdminTime)) ||
            (EVENING.includes(mar.AdminTime) &&
              EVENING.includes(med.newAdminTime))
          ) {
            
            result = true;
          }

          if (mar?.FollowUpPRN[0]?.IsNotify === true) {
            result = false;
          }
      

        });

      return result;
    },

    addSignature: function(med) {
      if (this.signed) {
        this.newSignature = this.staff + " - " + this.userSignatureTz;
      } else {
        this.newSignature = "";
      }

      if (med.signed) {
        med.newSignature = this.staff + " - " + this.userSignatureTz;
      } else {
        med.newSignature = "";
      }
    },
    clearSignatures: function(medicine) {
      medicine.newSignature = "";
    },

    onAddItem(item) {
      this.$refs.mar.addMAR(item);
    },

    amountAdministered(dosageAmount, qty) {
      let dosage = 0
      let totalDosage = 0;
      if (dosageAmount === "" || dosageAmount === undefined) return dosage;
      dosage = dosageAmount.replace(/,/g, "").split(/(\d+\.?\d*)/);
      totalDosage = dosage[1] * qty;
      return this.formattedTotalDosage(totalDosage) + dosage[2];
    },

    formattedTotalDosage(num) {
      return String(num).replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, "$&,");
    },

    togglePage() {
      if (this.page === "mar") {
        this.page = "history";
        this.currentPage(this.page);
        this.isPageHistory = true
      } else if (this.page === "history") {
        this.page = "mar";
        this.currentPage(this.page);
      } else {
        this.page = "mar";
        this.currentPage(this.page);
      }
    },
    toggleUnsignedPage(page) {
      console.log(page)
      this.currentPage(page);
      this.page = page;
      this.isPageHistory = false
    },

    currentPage(page) {
      this.$router.push({ name: "MAR", params: { page: page } }, () => {});
      this.page = page;
    },
  },
};
</script>

<style scoped></style>
